import { motion } from "framer-motion";
import { fadeUp, viewport } from "@/lib/motion";

export const Reveal = ({ children, className = "", delay = 0, variants = fadeUp, as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="show"
      viewport={viewport}
      transition={{ delay }}
    >
      {children}
    </MotionTag>
  );
};
